import axios from 'axios'
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { promotionalAddonUpdate, promotionalAddonDetails, logOutApi } from '../../../Context/api';
import { promotionalPlanValidation } from '../../../Context/validation';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';

const UseEditPromotionalAddOn = () => {
    const [spinner, setSpinner] = useState(false)
    const { id } = useParams()
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()
    
    useEffect(() => {
        messagePlanView()
    }, [])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId,type:'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const messagePlanView = () => {
        axios.post(promotionalAddonDetails(), { id: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                resp.data.data.planName = resp.data.data.name
                messagePlanEdit.setValues(resp.data.data)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
            }
        })
    }
    const messagePlanEdit = useFormik({
        initialValues: {
            price:"",
            planName:"",
            credit:"",
            description:""
        },
        validationSchema: promotionalPlanValidation,
        onSubmit: (values) => {
            const data = {
                credit:values.credit,
                description:values.description,
                price:values.price,
                name:values.planName,
                id: id
            }
            setSpinner(true)
            axios.post(promotionalAddonUpdate(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    navigate(-1)
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            }).catch(() => {
                toast.error(commonMessage.networkError)
            })
        }
    })
  return {
    spinner,
    messagePlanEdit
  }
}

export default UseEditPromotionalAddOn